(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PackageFeatureListSearch', PackageFeatureListSearch);

    PackageFeatureListSearch.$inject = ['$resource'];

    function PackageFeatureListSearch($resource) {
        var resourceUrl = 'api/_search/package-feature-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
